export const serviceUrl = 'https://launchaventure.softmarvel.com/api/';
// export const serviceUrl = '/';
export const tokenName = 'token';
export const iName = 'iname';